@if (isWidgetVisible()) {
  <div
    (click)="onCloseClick()"
    class="search-filters-mobile-panel-overlay"
  ></div>
  <div
    [ngClass]="animationClass()"
    class="search-filters-mobile-panel"
  >

    <app-search-places-v3 [showCloseButton]="true"></app-search-places-v3>
  </div>
}

